import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class RemoveChildDialog extends React.Component {
  state = {
    loading: false,
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.addChild();
      ev.preventDefault();
    }
  }

  removeChild = () => {
    this.setState({ loading: true });
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('accept', 'json')
      .send({ command: "removechild", child_id: this.props.child.id, parent_id: this.props.parentId })
      .end((err, res) => {
        var result = res.text.trim();
        if (result === "1") {
          //erfolgreich entfernt
          currentComponent.props.onChildRemoved();
        } else {
          currentComponent.setState({ snackbar_open: true, loading: false });
        }
      });
  }

  render() {
    const { classes, fullScreen } = this.props;
    return (
      <Dialog fullScreen={fullScreen} open={this.props.open}>
        <DialogTitle>{"Kind entfernen?"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          <DialogContentText>{"Wollen Sie " + this.props.child.first_name + " wirklich entfernen? Hierbei gehen die angegebenen Daten und die Wunschliste unwiederruflich verloren."}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onCancel} variant="contained" disabled={this.state.loading}>Abbrechen</Button>
          <Button onClick={this.removeChild} variant="contained" disabled={this.state.loading} color="primary" autoFocus>
            {this.props.child.first_name + " entfernen"}
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                Entfernen fehlgeschlagen. Versuchen Sie es später erneut.
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

RemoveChildDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChildRemoved: PropTypes.func.isRequired,
  child: PropTypes.object.isRequired,
  parentId: PropTypes.string.isRequired,
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(RemoveChildDialog));
